import { AgChartProps, AgCharts } from 'ag-charts-react';
import { useTranslation } from 'react-i18next';
import { formatToShortCst } from '../../../../utils/formatToShortCst';
import { DeviceData } from '../../../../types/DeviceData';

interface BloomChartProps {
  deviceData: DeviceData[];
}

export default function BloomCharts({ deviceData }: BloomChartProps) {
  const { t } = useTranslation();

  const formatedData = () =>
    deviceData.map(item => {
      return {
        ...item,
        createdAt: formatToShortCst(item.createdAt || ''),
      };
    });

  const tempChartOptions: AgChartProps['options'] = {
    title: {
      text: t('sites.digitalInputTitle'),
    },
    data: formatedData(),
    series: [
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.di1',
        yName: 'DI 1',
        marker: {
          enabled: false,
        },
      },
      {
        type: 'line',
        xKey: 'createdAt',
        yKey: 'data.di2',
        yName: 'DI 2',
        marker: {
          enabled: false,
        },
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        reverse: true,
        label: {
          enabled: false,
        },
      },

      {
        type: 'number',
        position: 'left',
        title: {
          text: t('sites.digitalInput'),
        },
      },
    ],
  };

  return (
    <>
      <AgCharts options={tempChartOptions} />
    </>
  );
}
